import { deleteExportsApi } from "./deleteExportsApi";

export const deleteExportsSetData = async (
  lang,
  setMessageResponse,
  cookies,
  outgoingId,
  setSuccessMessage
) => {
  const response = await deleteExportsApi(outgoingId, lang, cookies);
  if (response.success) {
    setSuccessMessage((prev) => ({
      ...prev,
      success: true,
      data: response.res.data,
    }));
  } else {
    const error = response.res;
    if (error.response) {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: error.response.data.message,
        isShow: true,
      }));
    } else {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: "Timeout",
        isShow: true,
      }));
    }
  }
};
